export default "__VITE_ASSET__Cjl4QFL3__"